import * as Yup from 'yup';

export const enterLocationValidationSchema = Yup.object({
  location: Yup.object()
    .shape({
      name: Yup.string().required(),
      state: Yup.string().required().min(2).max(3),
      post_code: Yup.string().required().min(4).max(4),
    })
    .required(),
}).required();
